import { Heading, HStack, VStack } from '@chakra-ui/react'

import type { SeriesPageHost } from '@/common/services/seriesPage/types'

import SeriesHostCard from './SeriesHostCard'

export default function SeriesHomeTutoredBy({
  hosts,
  worldSlug,
}: {
  hosts: SeriesPageHost[]
  worldSlug: string
}) {
  return (
    <VStack gap="16px" alignItems="stretch">
      <Heading size="xl">Tutored by</Heading>
      <HStack gap="16px" overflowX="auto" alignItems="stretch">
        {hosts.map(host => (
          <SeriesHostCard
            key={host.userId}
            host={host}
            worldSlug={worldSlug}
            hasFixedWidth={hosts.length > 1}
          />
        ))}
      </HStack>
    </VStack>
  )
}
